export default __webpack_public_path__ + "static/media/kapital.b675d990.gif";